import React from 'react';

export const ShortLineIcon = ({ className }) => {
	return (
		<svg width="24" height="2" viewBox="0 0 24 2" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="2" height="24" rx="1" transform="matrix(1.19249e-08 -1 -1 -1.19249e-08 24 2)" fill="#EDEDED" />
		</svg>
	);
};
